import { Box } from "@chakra-ui/react";
import React from "react";
import ProductSlider from "./ProductSlider";

const Carousal2 = () => {
  return (
    <Box>
      <ProductSlider />
    </Box>
  );
};

export default Carousal2;
